import { render, staticRenderFns } from "./JVxeInputCell.vue?vue&type=template&id=5a201c8e&scoped=true&"
import script from "./JVxeInputCell.vue?vue&type=script&lang=js&"
export * from "./JVxeInputCell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a201c8e",
  null
  
)

export default component.exports